
import { ApiURLs } from "../../../constant/ApiUrls";
import { deleteData, fetchData,updateData } from "../../../services/api";
import { toast } from 'react-toastify';

  


  export const addReportLisitingRequest = (page=1,pageSize=50,keyword='') => {

    return async (dispatch) => {

      const url = `${ApiURLs.ADREPORTS}?offset=${page}&limit=${pageSize}`;
  

      console.log('CHECK:::::::',url,pageSize);
      // wait untill the data not received so getData function take data and url part
      dispatch({"type":"GET_AD_REPORT_REQUEST"});
      try {
        var adReportData = await fetchData(url);
        console.log(`response when we try to get ad report  ${JSON.stringify(adReportData)}`)
        if (adReportData.status === 1) {
          dispatch({"type":"GET_AD_REPORT_REQUEST_SUCCESS", "payload":adReportData.data.result,"total":adReportData.data.total});
        
        } else {
          dispatch({"type":"GET_AD_REPORT_REQUEST_FAILED"});
        }
      } catch (error) {
        dispatch({"type":"GET_AD_REPORT_REQUEST_FAILED"});
        console.log(`error while try to get ad Report ${error}`)
      }
    }
  };



    export const deleteAdReport = (id) => {
      return async (dispatch) => {
    
        // dispatch();
        dispatch({"type":"DELETE_AD_REPORT_REQUEST"});
        try {
    
  
          var adReportResponse = await deleteData(`${ApiURLs.ADREPORTS}/${id}`);
          if (adReportResponse.status === 1) {
            dispatch({"type":"ADD_AD_REPORT_SUCCESS"});
            dispatch(addReportLisitingRequest());
          } else {
            dispatch({"type":"ADD_AD_REPORT_FAILED"});
          }
        } catch (error) {
          dispatch({"type":"ADD_AD_REPORT_FAILED"});
    
        }
      };
    };
  


 export const blockAd = (data, navigate) => {
   return async (dispatch) => {
     dispatch({"type":"ADD_AD_REPORT_REQUEST"});
     try {
       var adReportResponse = await updateData({body:data}, `${ApiURLs.ADS}/${data.id}`);
       if (adReportResponse.status === 1) {
         toast.success("Ad blocked successfully");
         dispatch({"type":"ADD_AD_REPORT_SUCCESS"});
         dispatch(addReportLisitingRequest());
       } else {
         dispatch({"type":"ADD_AD_REPORT_FAILED"});
       }
     } catch (error) {
       dispatch({"type":"ADD_AD_REPORT_FAILED"});
 
     }
   };
 };
    
    

